(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("widget-loading", [], factory);
	else if(typeof exports === 'object')
		exports["widget-loading"] = factory();
	else
		root["widget-loading"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(592);

/***/ }),

/***/ 357:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var Spacings = exports.Spacings = {
	    NONE: 'none',
	    SMALL: 'small',
	    MEDIUM: 'medium',
	    BIG: 'big'
	};
	Object.freeze(Spacings);
	
	var SPACING_OPTIONS = exports.SPACING_OPTIONS = [{ label: 'None', value: Spacings.NONE }, { label: 'Spacing small', value: Spacings.SMALL }, { label: 'Spacing medium', value: Spacings.MEDIUM }, { label: 'Spacing big', value: Spacings.BIG }];
	
	var SPACING_PREF = exports.SPACING_PREF = 'spacing';

/***/ }),

/***/ 358:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var Containers = exports.Containers = {
	    NONE: 'none',
	    REGULAR: 'regular'
	};
	Object.freeze(Containers);
	
	var CONTAINER_OPTIONS = exports.CONTAINER_OPTIONS = [{ label: 'None', value: Containers.NONE }, { label: 'Regular', value: Containers.REGULAR }];
	
	var CONTAINER_PREF = exports.CONTAINER_PREF = 'container';

/***/ }),

/***/ 562:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _controller = __webpack_require__(563);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Rowan de Zeeuw on 07/09/2018. Used source code from
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Backbase CXPContentWidget to create this extendable version.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  ----------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Author : Backbase R&D - Amsterdam - New York
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Filename : content.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Description:
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Source code for CXP Universal Content Widget
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  ----------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var bd = window.bd; /* eslint-disable-line no-unused-vars */
	var be = window.be; /* eslint-disable-line no-unused-vars */
	var $ = window.jQuery;
	
	var AbstractIceContentController = function (_AbstractWidgetBaseCo) {
	    _inherits(AbstractIceContentController, _AbstractWidgetBaseCo);
	
	    function AbstractIceContentController(widget) {
	        _classCallCheck(this, AbstractIceContentController);
	
	        //if (be.ice && bd && bd.designMode == 'true') {
	        var _this = _possibleConstructorReturn(this, (AbstractIceContentController.__proto__ || Object.getPrototypeOf(AbstractIceContentController)).call(this, widget));
	
	        !window.__TEST__ && _this.renderIceWidget();
	        //}
	        return _this;
	    }
	
	    _createClass(AbstractIceContentController, [{
	        key: 'renderIceWidget',
	        value: function renderIceWidget() {
	            var _this2 = this;
	
	            if (!be.ice) {
	                $('img[src=""], img:not([src])', this.widget.body).addClass('be-ice-hide-image');
	                $(this.widget.body).addClass('be-ice-widget-rendered');
	                return;
	            }
	            this.widget.iceConfig = be.ice.config;
	
	            if (this.cxpWidget.canEditContent()) {
	                this.cxpWidget.prepareCxpPreferences();
	
	                var templateUrl = String(this.widget.getPreference('templateUrl'));
	
	                var enableEditing = function enableEditing() {
	                    // it is possible to swap template for editorial
	                    // here is an example for image template
	                    if (templateUrl.match(/\/image\.html$/)) {
	                        templateUrl = templateUrl.replace(/\/image\.html$/, '/image-editorial.html');
	                    }
	
	                    return be.ice.controller.edit(_this2.widget, templateUrl).then(function (dom) {
	                        $(_this2.widget.body).find('.bp-g-include').html(dom.dom);
	                        return dom.dom;
	                    });
	                };
	
	                // this widget has property rendering example (template: simple.html)
	                // so we need to refresh widget after property 'title' modified
	                this.widget.model.addEventListener('PrefModified', function (oEvent) {
	                    if (oEvent.attrName === 'title') {
	                        enableEditing();
	                    }
	                }, false, this.widget);
	
	                enableEditing();
	            } else {
	                $(this.widget.body).addClass('be-ice-widget-rendered');
	            }
	        }
	    }]);
	
	    return AbstractIceContentController;
	}(_controller2.default);
	
	exports.default = AbstractIceContentController;

/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _cxpConfig = __webpack_require__(564);
	
	var _cxpConfig2 = _interopRequireDefault(_cxpConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AbstractWidgetBaseController = function () {
	    function AbstractWidgetBaseController(widget) {
	        _classCallCheck(this, AbstractWidgetBaseController);
	
	        this.widget = widget;
	        this.widgetPath = window.App.Portal.getWidgetPath(this.widget);
	        this.cxpWidget = new _cxpConfig2.default(widget);
	    }
	
	    _createClass(AbstractWidgetBaseController, [{
	        key: 'getSelector',
	        value: function getSelector(query) {
	            return this.widget.body.querySelector(query);
	        }
	    }, {
	        key: 'getSelectors',
	        value: function getSelectors(query) {
	            return this.widget.body.querySelectorAll(query);
	        }
	    }]);
	
	    return AbstractWidgetBaseController;
	}();
	
	exports.default = AbstractWidgetBaseController;

/***/ }),

/***/ 564:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global window, App */
	
	
	var _containers = __webpack_require__(358);
	
	var _spacings = __webpack_require__(357);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/* eslint-disable-next-line no-unused-vars */
	var bd = window.bd;
	/* eslint-disable-next-line no-unused-vars */
	var be = window.be;
	/* eslint-disable-next-line no-unused-vars */
	var b$ = window.b$;
	
	var CxpWidget = function () {
	    function CxpWidget(widget) {
	        _classCallCheck(this, CxpWidget);
	
	        this.widget = widget;
	        this.widgetName = widget.id.replace(/-\d+$/, '');
	
	        this.widget.addEventListener('DOMReady', this.disableClickOnDevelop.bind(this));
	    }
	
	    _createClass(CxpWidget, [{
	        key: 'addHelpTexts',
	        value: function addHelpTexts(propertyKeyTextMap) {
	            var map = Object.keys(propertyKeyTextMap).reduce(function (map, key) {
	                map[key] = { text: propertyKeyTextMap[key] };
	                return map;
	            }, {});
	            this.widget.helpTexts = map;
	        }
	    }, {
	        key: 'onPreferencesSave',
	        value: function onPreferencesSave(event) {
	            // override
	        }
	    }, {
	        key: 'isManageable',
	        value: function isManageable() {
	            var isMasterpage = be && be.utils ? be.utils.module('top.bd.PageMgmtTree.selectedLink')['isMasterPage'] : false;
	            var isInCxpMode = bd.designMode; //Changed be.cmis
	            var isManageable = isInCxpMode && (isMasterpage || this.widget.model.manageable === 'true' || this.widget.model.manageable === '' || this.widget.model.manageable === undefined);
	            return isManageable;
	        }
	    }, {
	        key: 'canEditContent',
	        value: function canEditContent() {
	            /* todo: this is (also) from the backbase content widget, but as I see it, you can only edit the widget if
	            *  you're admin or the creator? Need to check, else change the role here.
	            *  */
	            return this.isManageable() && be.ice.controller && /(?:ADMIN|CREATOR|MANAGER)/.test(this.widget.model.securityProfile);
	        }
	    }, {
	        key: 'prepareCxpPreferences',
	        value: function prepareCxpPreferences() {
	            var _this = this;
	
	            this.widget.addEventListener('preferences-form', function (event) {
	                _this._populatePreferencesForm(event);
	                //*changed
	                if (_this.onCxpPreferencesForm) {
	                    var observer = new MutationObserver(function (mutations) {
	                        var prefForm = document.querySelector('#PreferenceEditorContent');
	                        if (prefForm) {
	                            observer.disconnect();
	                            _this.onCxpPreferencesForm(prefForm);
	                        }
	                    });
	                    observer.observe(document, { attributes: true, childList: true, subtree: true });
	                }
	            });
	            this.widget.addEventListener('preferencesSaved', function (event) {
	                _this.widget.refreshHTML();
	            });
	            this.widget.addEventListener('savePreferenceForm', function (event) {
	                _this.onPreferencesSave(event);
	            });
	        }
	    }, {
	        key: '_populatePreferencesForm',
	        value: function _populatePreferencesForm(event) {
	            var aPrefs = b$.portal.portalModel.filterPreferences(this.widget.model.preferences.array);
	            for (var i = aPrefs.length - 1; i >= 0; i--) {
	                var preferenceItem = aPrefs[i];
	                var prefKey = preferenceItem.name;
	
	                switch (prefKey) {
	                    case _spacings.SPACING_PREF:
	                        this._populateOptions(preferenceItem, _spacings.SPACING_OPTIONS);
	                        break;
	                    case _containers.CONTAINER_PREF:
	                        this._populateOptions(preferenceItem, _containers.CONTAINER_OPTIONS);
	                        break;
	                    default:
	                        this._populateListItems(preferenceItem);
	                }
	            }
	        }
	    }, {
	        key: '_populateOptions',
	        value: function _populateOptions(preferenceItem, options) {
	            preferenceItem.inputType.options = options.map(function (spacing) {
	                return {
	                    label: spacing.label,
	                    value: spacing.value
	                };
	            });
	        }
	    }, {
	        key: '_populateListItems',
	        value: function _populateListItems(preferenceItem) {
	            var prefKey = preferenceItem.name;
	            var sTemplateVariants = this.widget.getPreference(prefKey + 'List');
	
	            if (!sTemplateVariants) {
	                return;
	            }
	
	            var arr = sTemplateVariants.split(',');
	            for (var j = 0, k = 0; j < arr.length; j++, k++) {
	                preferenceItem.inputType.options[k] = {
	                    label: arr[j].trim(),
	                    value: arr[j + 1].trim()
	                };
	                j++;
	            }
	        }
	    }, {
	        key: 'disableClickOnDevelop',
	        value: function disableClickOnDevelop(event) {
	            if (App.Portal.isInDesignMode()) {
	                this.widget.body.querySelectorAll('a').forEach(function (a) {
	                    a.addEventListener('click', function (e) {
	                        return e.preventDefault();
	                    });
	                });
	            }
	        }
	    }]);
	
	    return CxpWidget;
	}();
	
	exports.default = CxpWidget;

/***/ }),

/***/ 592:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _controller = __webpack_require__(593);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	App.Widgets.setWidgetStarterInNamespace('WidgetLoading', _controller2.default);

/***/ }),

/***/ 593:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _controller = __webpack_require__(562);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HELPERS = window.App.Utils.Helpers;
	var defaultModalID = 'modal-message';
	var defaultModalButtonID = 'cards-modal__button-for-ice__modal-message';
	
	var Controller = function (_AbstractIceContentCo) {
	    _inherits(Controller, _AbstractIceContentCo);
	
	    function Controller(widget) {
	        _classCallCheck(this, Controller);
	
	        var _this = _possibleConstructorReturn(this, (Controller.__proto__ || Object.getPrototypeOf(Controller)).call(this, widget));
	
	        _this.init(widget);
	        return _this;
	    }
	
	    _createClass(Controller, [{
	        key: 'init',
	        value: function init(widget) {
	            if (b$.portal.loggedInUserGroup.length === 0) {
	                var tryAgain = function tryAgain() {
	                    App.PubSub.publish(defaultModalID, errorModalData);
	                    document.getElementById(defaultModalButtonID).onclick = function () {
	                        _authenticateUser();
	                        App.PubSub.publish(defaultModalID, "hide");
	                    };
	                };
	
	                var _authenticateUser = function _authenticateUser() {
	                    var xhr = new XMLHttpRequest();
	                    var endpoint = HELPERS.adaptEnvironment(decodeURI(widget.getPreference('apiEndpoint')), false);
	                    var headers = decodeURI(widget.getPreference('oAuthHeaders'));
	                    var parsedHeaders = JSON.parse(headers);
	
	                    if (customerToken) {
	                        parsedHeaders.customerCCPQToken = customerToken;
	                    }
	
	                    xhr.open("GET", endpoint, true);
	                    xhr.withCredentials = true;
	                    xhr.setRequestHeader("Content-type", parsedHeaders["contentType"]);
	                    xhr.setRequestHeader("intSvcName", parsedHeaders["intSvcName"]);
	                    xhr.setRequestHeader("service", parsedHeaders["service"]);
	                    xhr.timeout = HELPERS.getApiRequestTimeout();
	                    xhr.ontimeout = function (e) {
	                        tryAgain();
	                    };
	
	                    xhr.onreadystatechange = function () {
	                        if (xhr.readyState === 4) {
	                            var result = {};
	                            try {
	                                result = JSON.parse(xhr.response);
	                            } catch (err) {
	                                result = xhr.response;
	                            }
	
	                            if (xhr.status === 200) {
	                                if (result && result.status === "success") {
	                                    var bbxsrfCookie = window.App.Utils.Object.getJourneyCookie("BBXSRF");
	                                    _getAPICall(customerToken, bbxsrfCookie); //Continue with submission
	                                } else {
	                                    App.PubSub.publish("redirectToErrorPage", {
	                                        status: 400, //if 200, gets redirected to error page with Service Temporarily Unavailable
	                                        code: notHttpResponse.error_code,
	                                        body: notHttpResponse,
	                                        errorPage: '/' + HELPERS.getRelativePath() + errorPage,
	                                        withIcon: false
	                                    });
	                                }
	                            } else {
	                                App.PubSub.publish("redirectToErrorPage", {
	                                    status: xhr.status,
	                                    code: result.error_code,
	                                    body: result,
	                                    errorPage: '/' + HELPERS.getRelativePath() + errorPage,
	                                    withIcon: false
	                                });
	                            }
	                        }
	                    };
	                    return xhr.send(null);
	                };
	
	                var _getAPICall = function _getAPICall(customerToken, bbxsrfCookie) {
	                    var body = {
	                        customerCCPQToken: customerToken
	                    };
	
	                    var xhr = new XMLHttpRequest();
	                    var endpoint = HELPERS.adaptEnvironment(decodeURI(widget.getPreference('apiEndpoint')), false);
	                    var headers = decodeURI(widget.getPreference('pullHeaders'));
	                    var parsedHeaders = JSON.parse(headers);
	
	                    body = _getUTMParams(body);
	
	                    xhr.open("POST", endpoint, true);
	                    xhr.withCredentials = true;
	                    xhr.setRequestHeader("Content-type", parsedHeaders["contentType"]);
	                    xhr.setRequestHeader("intSvcName", parsedHeaders["intSvcName"]);
	                    xhr.setRequestHeader("service", parsedHeaders["service"]);
	                    xhr.setRequestHeader("X-BBXSRF", bbxsrfCookie);
	                    xhr.timeout = HELPERS.getApiRequestTimeout();
	                    xhr.ontimeout = function (e) {
	                        tryAgain();
	                    };
	                    xhr.onreadystatechange = function () {
	                        if (xhr.readyState === 4) {
	                            var result = {};
	
	                            try {
	                                result = JSON.parse(xhr.response);
	                            } catch (err) {
	                                result = xhr.response;
	                            }
	
	                            if (xhr.status === 200 && result && result.status === "success") {
	
	                                _checkResult(result, bbxsrfCookie, propertyToCheck, errorTransactionPage);
	                            } else if ((xhr.status === 200 || xhr.status === 400) && (!result || !result.status && !result.error_code)) {
	
	                                App.PubSub.publish("redirectToErrorPage", {
	                                    status: 400,
	                                    code: notHttpResponse.error_code,
	                                    body: notHttpResponse,
	                                    errorPage: '/' + HELPERS.getRelativePath() + errorPage,
	                                    withIcon: false
	                                });
	                            } else {
	
	                                App.PubSub.publish("redirectToErrorPage", {
	                                    status: xhr.status,
	                                    code: result.error_code,
	                                    body: result,
	                                    errorPage: '/' + HELPERS.getRelativePath() + errorPage,
	                                    withIcon: false
	                                });
	                            }
	                        }
	                    };
	                    return xhr.send(JSON.stringify(body));
	                };
	
	                var _getUTMParams = function _getUTMParams(body) {
	                    UTMParams.split(',').forEach(function (utm) {
	                        var utmFound = searchParams.get(utm.trim());
	                        if (utmFound && utmFound.length !== 0) {
	                            body[utm.replace(/_([a-z])/g, function (g) {
	                                return g[1].toUpperCase();
	                            })] = utmFound;
	                        } else {
	                            console.log('missing UTM parameter: ' + utm);
	                        }
	                    });
	                    return body;
	                };
	
	                //Initialize data to save to sessionStorage: ex. otpSummary
	
	
	                var initDataInStorage = function initDataInStorage(parsedDataStructure) {
	                    if (dataInitialization.length > 0 && dataInitializationName.length > 0) {
	                        var dataInit = {};
	                        var parsedDataInit = JSON.parse(dataInitialization);
	                        var dataInitTarget = Object.assign({}, parsedDataInit, parsedDataStructure);
	                        dataInit.body = dataInitTarget;
	
	                        App.PubSub.subscribe("initializeInStorage", function (encryptedData) {
	                            sessionStorage.setItem(dataInitializationName, encryptedData);
	                            HELPERS.goToPage('/' + HELPERS.getRelativePath() + successPage);
	                        });
	
	                        HELPERS.encryptDecrypt(dataInit, encryptionEndpoint, encryptionHeaders, true, errorPage, "initializeInStorage");
	                    }
	                };
	
	                var _checkResult = function _checkResult(result, bbxsrfCookie, propertyToCheck, redirectPage) {
	                    if (result.status === "success") {
	                        var parsedDataStructure = App.Utils.Object.transformMapData(result, dataSchema);
	                        initDataInStorage(parsedDataStructure); //Continue with Backend Encryption
	
	                        if (redirectPage.length > 0) {
	                            if (bbxsrfCookie === null || !result.body || !result.body.hasOwnProperty(propertyToCheck) || result.body[propertyToCheck].length === 0) {
	                                HELPERS.goToPage('/' + HELPERS.getRelativePath() + redirectPage);
	                            }
	                        }
	                    } else {
	                        var _notHttpResponse = {
	                            status: result.status,
	                            description: result.description,
	                            message: result.message
	                        };
	
	                        sessionStorage.setItem('notHttpResponse', JSON.stringify(_notHttpResponse));
	                        HELPERS.goToPage('/' + HELPERS.getRelativePath() + errorPage);
	                    }
	                };
	
	                HELPERS.confirmOnLeave();
	
	                var successPage = decodeURI(widget.getPreference('successPage'));
	                var errorPage = decodeURI(widget.getPreference('errorPage'));
	                var errorTransactionPage = decodeURI(widget.getPreference('errorTransactionPage'));
	                var propertyToCheck = decodeURI(widget.getPreference('propertyToCheck'));
	                var encryptionEndpoint = HELPERS.adaptEnvironment(decodeURI(widget.getPreference('apiEndpoint')), true);
	                var encryptionHeadersPref = decodeURI(widget.getPreference('encryptionHeaders'));
	                var encryptionHeaders = JSON.parse(encryptionHeadersPref);
	                var errorModalData = {
	                    "content": "",
	                    "isIce": true,
	                    "size": "small",
	                    "disableScroll": true,
	                    "showCloseIcon": true,
	                    "showButton": true
	                };
	                var dataSchema = JSON.parse(decodeURI(widget.getPreference('dataSchema')));
	                var dataInitialization = decodeURI(widget.getPreference('dataInitialization'));
	                var dataInitializationName = decodeURI(widget.getPreference('dataInitializationName'));
	                var notHttpResponse = JSON.parse(decodeURI(widget.getPreference('errorDetails')));
	                var UTMParams = decodeURI(widget.getPreference('z_UTMparams'));
	                var searchParams = new URLSearchParams(window.location.search);
	                var customerToken = searchParams.get('ct');
	
	                if (customerToken && customerToken.length > 0) {
	                    //Remove ct (customerToken) on the url params so it will not be included when forwarding the urlParams to the successPage
	                    history.replaceState && history.replaceState(null, '', location.pathname + location.search.replace(/[\?&]ct=[^&]+/, '').replace(/^&/, '?'));
	                }
	
	                var windowLocation = window.location.href;
	                var urlParams = windowLocation.split('?')[1];
	
	                if (urlParams) {
	                    successPage = successPage + '?' + urlParams;
	                }
	
	                HELPERS.removeFromStorage();
	                sessionStorage.removeItem('integrationData');
	                sessionStorage.removeItem('httpResponse');
	                HELPERS.deleteCookie('BBXSRF');
	
	                if (navigator.onLine) {
	                    _authenticateUser();
	                } else {
	                    tryAgain();
	                }
	            }
	        }
	    }]);
	
	    return Controller;
	}(_controller2.default);
	
	exports.default = Controller;

/***/ })

/******/ })
});
;


// WEBPACK FOOTER //
// widget-loading/scripts/widget-loading.js